import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbSDKRouteStateHelper;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * AbSDKRouteState is serializable window.history 'state' object.  It holds the
 * absdk related state in a special __routeState member so that it could potentially
 * be combined with app-specific state structure if we decide to support app-specific state.
 */

export class AbSDKRouteStateHelper {
  constructor() {
    _defineProperty(this, "_lastRouteTimestamp", Date.now());
  }
  get lastRouteTimestamp() {
    return this._lastRouteTimestamp;
  }
  set lastRouteTimestamp(newVal) {
    this._lastRouteTimestamp = newVal;
  }
  get nextLastRouteTimestamp() {
    return this._lastRouteTimestamp++;
  }
}

// Guarantee unique timestamp based on Date.now(). Timestamp values from previous browser sessions
// will always be less than timestamps from current session (ignoring manual clock changes!)
_AbSDKRouteStateHelper = AbSDKRouteStateHelper;
_defineProperty(AbSDKRouteStateHelper, "SINGLETON", new _AbSDKRouteStateHelper());
export function buildAbSDKRouteState(route) {
  return {
    __routeState: {
      route,
      timestamp: AbSDKRouteStateHelper.SINGLETON.nextLastRouteTimestamp
      // timestamp: performance.timeOrigin + performance.now(),
    }
  };
}
export function isAbSDKRouteState(historyRouteState) {
  return historyRouteState?.__routeState;
}
//# sourceMappingURL=AbSDKRouteState.js.map
